import base from "/opt/build/repo/images/youtube.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");